import Logout from "@mui/icons-material/Logout"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import MenuItem from "@mui/material/MenuItem"
import { Stack } from "@mui/system"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import DialogProvider from "@components/dialog_provider"
import { useLeftNavigationContext } from "@contexts/left_navigation_context"
import useToggle from "@hooks/use_toggle"

export type LogoutFormData = {
  optionList: string
}

export default function LogoutDialogRow() {
  const [isDialogOpen, toggleIsDialogOpen] = useToggle(false)
  const { translate } = useLeftNavigationContext()
  return (
    <>
      <MenuItem onClick={toggleIsDialogOpen}>
        <ListItemIcon>
          <Logout />
        </ListItemIcon>
        <ListItemText>{translate("logout")}</ListItemText>
      </MenuItem>
      <LogoutDialog open={isDialogOpen} setClose={toggleIsDialogOpen} />
    </>
  )
}

function LogoutDialog({
  open,
  setClose
}: {
  open: boolean
  setClose: () => void
}) {
  const { translate, logoutUser } = useLeftNavigationContext()
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  function onSubmit() {
    if (loading) {
      return
    }
    setLoading(true)
    logoutUser?.()
    setLoading(false)
    closeDialog()
    navigate("/public/login")
  }

  function handleSubmit() {
    onSubmit()
  }

  function closeDialog() {
    if (loading) {
      false
    }
    setClose()
  }

  return (
    <DialogProvider
      title={translate("logout")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: closeDialog || loading
      }}
      rightButton={{
        text: translate("logout"),
        color: "error",
        onClick: () => handleSubmit(),
        loading: loading
      }}
      isOpen={open}
      setClose={closeDialog}
      size="small"
    >
      <Stack sx={{ textAlign: "center" }}>{translate("logout_warning")}</Stack>
    </DialogProvider>
  )
}
